import type React from "react";
import type {DeserializedGridCellParams} from "../../../../../../components/muix-data-grid/MuiXColumnDefinitions.ts";
import type {PartGridGroupModel, PartGridRowModel} from "../CategorizationTableDataModel.ts";
import type {BusinessUnit} from "../../../../../../services/classes/MaterializedClasses.ts";
import {showBusinessUnit} from "../../../../../../stores/managers/BusinessUnitManager.ts";

type Props = DeserializedGridCellParams<PartGridRowModel>;
export const BusinessUnitCell: React.FC<Props> = ({rowNode, formattedValue, row}) => {
    if (rowNode.type === 'group') {
        // field === GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD
        const groupRow = row as unknown as PartGridGroupModel;
        if ((groupRow.bu_id_agg?.length ?? 0) === 1) {
            const aggBu: BusinessUnit = {
                id: -1,
                databag_id: -1,
                bu_id: groupRow.bu_id_agg?.at(0) ?? '',
                bu_name: groupRow.bu_name_agg?.at(0) ?? '',
            }
            return showBusinessUnit(aggBu);
        }
        return groupRow.bu_count_agg;
    }
    return formattedValue;
}
